export const GET_ORG_WALLET_START = 'GET_ORG_WALLET_START';
export const GET_ORG_WALLET_SUCCESS = 'GET_ORG_WALLET_SUCCESS';
export const GET_ORG_WALLET_ERROR = 'GET_ORG_WALLET_ERROR';
export const GET_ORG_WALLET_END = 'GET_ORG_WALLET_END';
